import React from 'react';
import { stages } from '../data/coachSystem';
export function SystemSection() {
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="system-title" data-id="element-122" data-mp="3ghgcpd6of88r">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-123" data-mp="3biwn92svjebn">
        <p className="eyebrow text-[0.66rem] font-semibold text-teal sm:text-[0.72rem]" data-id="element-124" data-mp="3bkpykvefmmpz">
          A more organized way to coach
        </p>
        <h2 id="system-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-125" data-mp="31kz58x1lydrh">
          Your coaching isn’t the problem.
          <span className="mt-1 block text-navy-muted" data-id="element-126" data-mp="2stglyd9d7hu6">
            Building every practice from scratch is.
          </span>
        </h2>

        <div className="mx-auto mt-5 max-w-2xl space-y-3.5" data-id="element-127" data-mp="2nr7tdi0emhsl">
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-128" data-mp="2iswgsziq5t6o">
            You already care about your players. The exhausting part is
            everything around the session: finding a drill that actually fits,
            deciding what to work on, explaining a play in a way the team
            understands, and figuring out the next practice the night before.
          </p>
          <p className="text-[0.98rem] leading-relaxed text-navy-muted" data-id="element-129" data-mp="u23a76aw4l7j">
            When your coaching lives across saved videos, screenshots, scribbled
            notes and whatever you can remember, planning becomes the job. Girls
            Flag Football Coach System™ brings all of it into one written
            structure you open and run.
          </p>
        </div>

        <ol className="mx-auto mt-6 max-w-4xl divide-y divide-navy-line border-y border-navy-line sm:grid sm:grid-cols-3 sm:gap-x-8 sm:divide-y-0 sm:border-y-0" data-id="element-130" data-mp="1crry4fgbr1de">
          {stages.map((stage, index) => <li key={stage.label} className="flex flex-col items-center py-4 sm:border-t sm:border-navy-line" data-id="element-131" data-mp="1bv081qid741" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-light text-[0.78rem] font-bold text-teal-deep" data-id="element-132" data-mp="69czf0eq47yu">
                {index + 1}
              </span>
              <h3 className="mt-2.5 text-[0.85rem] font-bold uppercase tracking-[0.14em] text-navy" data-id="element-133" data-mp="2414paaclbmcd">
                {stage.label}
              </h3>
              <p className="mt-1 text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-134" data-mp="1ua0b3cuqo5il">
                {stage.description}
              </p>
            </li>)}
        </ol>

        <p className="mx-auto mt-6 max-w-md border-t-2 border-sand pt-4 text-[1.02rem] font-semibold leading-snug text-navy" data-id="element-135" data-mp="1l8scetob92nz">
          Less time planning practices.
          <span className="block font-normal text-navy-muted" data-id="element-136" data-mp="1g9pf5veko0qk">
            More time actually coaching them.
          </span>
        </p>
      </div>
    </section>;
}